module.exports = __webpack_public_path__ + "img/presupuesto_abierto.2afce024.svg";